<template>
  <div>
    <headerSection mainMenu="rewards"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Rewards Cover Section -->
          <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <img src="../assets/images/cover-redeem-bg.jpg" class="-bg" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง phenix789">
            <img src="../assets/images/cover-redeem-bg-mobile.jpg" class="-bg -mobile" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง phenix789">

            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content"></div>
                <div class="col-12 col-md-6 -right-content bg-mobile">
                  <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                    <div class="slick-list draggable" style="height: 58px;">
                      <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                        <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                          <h1 class="-title">ของรางวัลเพียบ <br>  จัดหนัก แลกได้ตลอดเวลา</h1>
                          <p class="-sub-title">สะสมเหรียญเพื่อแลกของรางวัลที่มีได้หมด ทุกเวลา</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Rewards Content -->
          <div class="content-wrapper">
            <!-- Rewards Cards Section -->
            <div class="x-event-index-container">
              <div class="container">
                <div class="row -event-row-wrapper">
                  <div class="col-lg-4 col-6 -col-wrapper" v-for="(item,index) in rewards" :key="index">
                    <div class="-card-item animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
                      <a class="d-block h-100 -card-link-wrapper">
                        <div class="x-card card -multi-card">
                          <div class="-img-container">
                            <img :src="item.image" :alt="item.name" class="-img">
                          </div>
                          <div class="card-body">
                            <div class="-title-container m-3">
                              <h3 class="-title">{{item.name}}</h3>
                              <div data-v-d9ae3272="" class="-deposit-container d-xl-block">
                                <a data-v-d9ae3272="" class="text-white js-account-approve-aware btn -btn-redeem" :disabled="(!user || !user.key || !user.coin || Number(user.coin)<item.point)?true:false" @click="redeem(item)">
                                  <div data-v-d9ae3272="" class="f-7">แลกทันที</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Rewards Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" style="padding-top: 63px;">
          <img src="../assets/images/cover-redeem-bg.jpg" class="-bg" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง phenix789">
          <img src="../assets/images/cover-redeem-bg-mobile.jpg" class="-bg -mobile" alt="สูตรสล็อต สูตรบาคาร่า เจ้าแรกในไทย ผ่านเว็บตรง phenix789">

          <div class="container-fluid">
            <div class="row -contents-wrapper">
              <div class="col-12 col-md-6 -left-content"></div>
              <div class="col-12 col-md-6 -right-content bg-mobile">
                <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                  <div class="slick-list draggable" style="height: 58px;">
                    <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                      <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                        <h1 class="-title">ของรางวัลเพียบ <br>  จัดหนัก แลกได้ตลอดเวลา</h1>
                        <p class="-sub-title">สะสมเหรียญเพื่อแลกของรางวัลที่มีได้หมด ทุกเวลา</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Rewards Content -->
            <div class="mobile-content-wrapper">
              <!-- Mobile Rewards Cards Section -->
              <div class="x-event-index-container">
                <div class="container">
                  <div class="row -event-row-wrapper">
                    <div class="col-lg-4 col-6 -col-wrapper" v-for="(item,index) in rewards" :key="index">
                      <div class="-card-item animated fadeInUp" data-animatable="fadeInUp" data-delay="200">
                        <a class="d-block h-100 -card-link-wrapper">
                          <div class="x-card card -multi-card">
                            <div class="-img-container">
                              <img :src="item.image" :alt="item.name" class="-img">
                            </div>
                            <div class="card-body">
                              <div class="-title-container m-3">
                                <h3 class="-title">{{item.name}}</h3>
                                <div data-v-d9ae3272="" class="-deposit-container d-xl-block">
                                  <a data-v-d9ae3272="" class="text-white js-account-approve-aware btn -btn-redeem" :disabled="(!user || !user.key || !user.coin || Number(user.coin)<item.point)?true:false" @click="redeem(item)">
                                    <div data-v-d9ae3272="" class="f-7">แลกทันที</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
const axios = require('axios').default
export default {
  name: 'Home',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  mounted () {
    // Bonn.boots.push(function() {
    //   setTimeout(function() {
    //     $('#bankInfoModal').modal('show');
    //   }, 500);
    // });
    this.$store.dispatch('user/getRewards').catch(err => { console.error(err) })
    // this.checkAnoucement()
  },
  computed: {
    sites_credit () {
      return this.$store.state.user.sites_credit
    },
    user () {
      return this.$store.state.user.user
    },
    rewards () {
      return this.$store.state.user.rewards
    },
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    lastbonus () {
      return this.$store.state.user.lastbonus
    }
  },
  data () {
    return {
      continueCheck: false,
      receiveAnounceMent: false,
      anoucement: {},
      balance: 0,
      fa_spin: false,
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  methods: {
    async conFirmRedeem (item) {
        this.$confirm(
          {
            message: `ต้องการแลกของรางวัล ${item.name}`,
            button: {
              yes: 'ยินยัน',
              no: 'ยกเลิก'
            },
            callback: confirm => {
              if (confirm) {
                this.$store.commit('user/SET_LOADING', true)
                setTimeout(() => {
                  firebase.firestore().collection('redeem').add({
                    userkey: this.user.key,
                    code: this.user.code,
                    firstname: this.user.firstname || '',
                    lastname: this.user.lastname || '',
                    reward: item.key,
                    type: item.type,
                    credit: (item.credit) ? item.credit : '',
                    point: item.point,
                    status: false,
                    createdate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                  }).then((result) => {
                    axios({
                      method: 'post',
                      url: 'https://phenix.apifast.xyz/qmovetowallet/redeem',
                      data: {
                        code: this.user.code,
                        key: result.id
                      }
                    })
                    this.$store.commit('user/SET_LOADING', false)
                  })
                }, Math.floor(Math.random() * 3000))
              }
            }
          }
        )
    },
    async redeem (item) {
      if (!(!this.user || !this.user.key || !this.user.coin || Number(this.user.coin) < item.point)){
        if (item.type === 'credit') {
          this.$store.dispatch('user/refreshCreditAll').finally(res => {
            if (this.sites_credit.credit >= 5) {
              this.$swal({ icon: 'error', title: 'แลกเครดิต', html: 'ไม่สามารถแลกเครดิตได้เนื่องจากมียอดคงเหลือมากกว่า 5 บาท' })
            } else {
              this.conFirmRedeem(item)
            }
          })
        } else {
          this.conFirmRedeem(item)
        }
      }
    },
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    }
    // async moveCreditToWallet () {
    //   this.$store.commit('user/SET_LOADING', true)
    //   const user = this.getUserId()
    //   this.$store.dispatch('user/moveCreditToWallet').catch(err => { console.error(err) })
    //   this.$store.dispatch('user/getLastBonus', user).finally(res => {
    //     this.$store.commit('user/SET_LOADING', false)
    //     if (this.lastbonus.turncredit) {
    //       this.$store.commit('user/SET_ALERT_WITHDRAWALL', true)
    //     }
    //   }).catch(err => { console.error(err) })
    // },
  }
}
</script>
<style scoped>

/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  margin-left: 100px;
  padding-top: 105px;
  width: calc(100% - 100px);
  min-height: 100vh;
  background-image: url('../assets/images/background/desktop.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Ensure x-cover appears above menu */
.main-content .x-cover {
  position: relative;
  z-index: 0;
}

.content-wrapper {
  padding: 20px;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding-top: 105px;
  min-height: 100vh;
  background-image: url('../assets/images/background/mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Mobile cover section positioning */
.mobile-layout .mobile-cover {
  margin-top: -105px;
  padding-top: 105px;
}

.mobile-with-sidebar {
  display: flex;
  min-height: calc(100vh - 300px);
}

.mobile-content-wrapper {
  padding: 10px;
}

/* Mobile x-cover positioning */
.mobile-cover {
  position: relative;
  /* z-index: 10; */
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: hidden;
}

.mobile-cover .-bg {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-height: 200px;
}

.mobile-cover .-bg.-mobile {
  display: block;
}

.mobile-cover .-bg:not(.-mobile) {
  display: none;
}

.mobile-cover .container-fluid {
  padding: 10px;
}

.mobile-cover .-title {
  font-size: 18px !important;
  line-height: 1.3;
  margin-bottom: 5px;
}

.mobile-cover .-sub-title {
  font-size: 14px !important;
  line-height: 1.2;
}

/* Responsive Utilities */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .desktop-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }
}

@media (max-width: 768px) {
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }
}

/* Existing Rewards Styles */
/* Mobile responsive adjustments */
@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }

    .mobile-cover {
        max-height: 250px;
    }

    .mobile-cover .-bg {
        max-height: 150px;
    }

    .mobile-cover .-title {
        font-size: 16px !important;
    }

    .mobile-cover .-sub-title {
        font-size: 12px !important;
    }
}

.bg-mobile2 {
  margin-right: 100px;
}

@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }
    .bg-mobile {
      background-color: #1c1c1c;
    }
    .bg-mobile2 {
      margin-right: 0;
    }
}

.btn {
    border-radius: 25px;
    color: #fff;
    border: none;
    padding: 0.8rem 2.5rem;
}

.btn.-btn-redeem{background:radial-gradient(100% 100% at 50% 0,#a8ff9c 0,#4dd842 100%);box-shadow:0 2px 4px rgba(0,0,0,.12),0 1px 2px hsla(0,7.3%,92%,.24)}
.btn.-btn-redeem:hover{background:radial-gradient(100% 100% at 50% 0,#a8ff9b 0,#33bf28 100%)}
.btn.-btn-redeem:disabled,
.btn.-btn-redeem[disabled]{background:radial-gradient(100% 100% at 50% 0,#cccccc 0,#9e9999 100%)}
</style>
